import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EquipmentItemDto } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';

@Component({
  standalone: false,
  selector: 'wr-tga-type-popover',
  templateUrl: './tga-type-popover.component.html',
  styleUrls: ['./tga-type-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TgaTypePopoverComponent {
  readonly router = inject(Router);

  @Input()
  @Tracked()
  tgaType?: EquipmentItemDto;

  @Input()
  @Tracked()
  disableLink = false;

  loading = loader();

  readonly picture = computed(() => {
    return this.tgaType?.icon?.presignedUrl ?? '';
  });

  navigateToDetail() {
    this.router.navigate(['equipment', this.tgaType!.id]);

  }
}
